export default "__VITE_ASSET__DwSYQ56o__"